var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app" },
    [
      _c("div", { staticClass: "registerBox" }, [
        _c("p", { staticClass: "shopName" }, [
          _vm._v(_vm._s(_vm.shopInfo.name))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "welcome_join" }, [
          _vm._v("欢迎您成为尊贵的会员")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rightBox" },
          [
            _c("div", { staticClass: "Requirement" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.name,
                    expression: "name"
                  }
                ],
                staticClass: "rigRe",
                attrs: { type: "text", placeholder: "请输入姓名" },
                domProps: { value: _vm.name },
                on: {
                  focus: _vm.focus,
                  blur: _vm.blur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.name = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "Requirement margintops" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.tel,
                    expression: "tel"
                  }
                ],
                staticClass: "rigRe fr",
                attrs: {
                  type: "number",
                  placeholder: "请输入手机号",
                  pattern: "[0-9]*"
                },
                domProps: { value: _vm.tel },
                on: {
                  focus: _vm.focus,
                  blur: _vm.blur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.tel = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "Requirement margintops flexbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.vcode,
                    expression: "vcode"
                  }
                ],
                staticClass: "rigRe",
                staticStyle: { width: "57%" },
                attrs: {
                  type: "number",
                  placeholder: "请输入验证码",
                  pattern: "[0-9]*"
                },
                domProps: { value: _vm.vcode },
                on: {
                  focus: _vm.focus,
                  blur: _vm.blur,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.vcode = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "vcodeSty",
                  class: _vm.itemFlase ? "" : "vcodeStyFa",
                  on: { click: _vm.clickVcode }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.itemFlase ? "获取验证码" : _vm.idx) +
                      "\n        "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "Determine",
                class: _vm.disabled === true ? "dis" : "",
                on: {
                  click: function($event) {
                    _vm.disabled === true ? "" : _vm.clickApply()
                  }
                }
              },
              [_vm._v("\n        注册\n      ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              { staticClass: "vip_bind", on: { click: _vm.handleToBind } },
              [_vm._v("已有账号，去绑卡")]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "vip_tit" }, [
              _vm._v("----" + _vm._s(_vm.shopInfo.content.title || "") + "----")
            ]),
            _vm._v(" "),
            _vm._l(_vm.shopInfo.content.content, function(item, idx) {
              return _c("p", { key: idx, staticClass: "vip_detail" }, [
                _vm._v("\n        (2022-2-12至2022-5-20)\n      ")
              ])
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _vm.load ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.toast,
              expression: "toast"
            }
          ],
          staticClass: "toast"
        },
        [_vm._v(_vm._s(_vm.toastText))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-879d3aba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879d3aba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/RegisterByCode/index.vue
// module id = null
// module chunks = 